import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import { IconButton, Tooltip } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export default function StepForwardButton({stepForward, lastStep, stepIsCompleted}) {
    return (
        <div className="wrapper" id='stepForwardWrapper'>
            <Tooltip title="Nächster Abschnitt" TransitionComponent={Zoom} arrow>
                <IconButton
                    color="primary"
                    onClick={stepForward}
                    disabled={lastStep || !stepIsCompleted}
                >
                    <KeyboardDoubleArrowRight />
                </IconButton>
            </Tooltip>
        </div>
    );
} 